var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.page ? _c('main', {
    staticClass: "page-container effect--fade-slide-in"
  }, [_vm.visibleHeader ? _c('SanityPageHeader', {
    attrs: {
      "fixed": _vm.fixedHeader
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sanity-modules-container"
  }, _vm._l(_vm.page.modules, function (module) {
    return _c('SanityModule', {
      key: module._key,
      attrs: {
        "data": module
      }
    });
  }), 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };